import React from 'react'

const Subtitle = () => {
  return (
    <h2 className="text-lg md:text-xl font-raleway">FIND BIDFTA NEAR YOU</h2>
  )
}

export default Subtitle
